var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.23 15.6-2.358-3.022V7.329a3.061 3.061 0 0 0-1.249-2.338A4.392 4.392 0 0 0 10.989 4h-.26a4.4 4.4 0 0 0-2.634.991 3.063 3.063 0 0 0-1.249 2.338v5.249L4.488 15.6H17.23m-6.274 3.218a2.149 2.149 0 0 1-2.1-1.714h4.2a2.15 2.15 0 0 1-2.1 1.714zm7.228-2.218H3.533a.534.534 0 0 1-.421-.862l2.734-3.503V7.329a4.039 4.039 0 0 1 1.617-3.113A5.363 5.363 0 0 1 10.729 3h.26a5.358 5.358 0 0 1 3.266 1.216 4.036 4.036 0 0 1 1.617 3.113v4.906l2.733 3.507a.534.534 0 0 1-.421.862z",
    "data-name": "Path 11634"
  })));
};
export default SvgBell;